var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.38663 13.4421C9.33975 13.3965 9.1393 13.224 8.97441 13.0634C7.93741 12.1217 6.24004 9.66496 5.72194 8.37913C5.63869 8.18385 5.46249 7.69015 5.45117 7.42637C5.45117 7.17362 5.50937 6.93267 5.62737 6.70275C5.79226 6.41614 6.05172 6.18621 6.35805 6.06023C6.57062 5.97913 7.20673 5.85314 7.21805 5.85314C7.91397 5.72716 9.04473 5.65787 10.2943 5.65787C11.4849 5.65787 12.5696 5.72716 13.276 5.83031C13.2873 5.84212 14.0778 5.9681 14.3486 6.1059C14.8432 6.35866 15.1504 6.85236 15.1504 7.3807V7.42637C15.1383 7.77047 14.8311 8.49409 14.8198 8.49409C14.3009 9.71063 12.6868 12.1106 11.6142 13.0752C11.6142 13.0752 11.3386 13.3468 11.1664 13.465C10.9191 13.6492 10.6128 13.7406 10.3064 13.7406C9.96454 13.7406 9.64608 13.6374 9.38663 13.4421Z",
    fill: "#F9FAFB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.f41dad18f1616cc868e7fadf6d4f109c.svg";
export { ForwardRef as ReactComponent };